import { escapeRegExp } from "@web-app/pages/common/OrdersSidebar/utils";

export default function HighlightString({
  searchTerm,
  text,
}: {
  searchTerm: string | undefined;
  text: string;
}) {
  if (!searchTerm) {
    return <span>{text}</span>;
  }

  const regex = new RegExp(`(${escapeRegExp(searchTerm)})`, "gi");
  const parts = text.split(regex);

  return (
    <span className="truncate text-ellipsis">
      {parts.map((part, index) =>
        regex.test(part) ? (
          <mark key={index}>{part}</mark>
        ) : (
          <span key={index}>{part}</span>
        ),
      )}
    </span>
  );
}
